<template>
  <help-info-wrapper :info.sync="helpData" :service-name="serviceName" class="warp">
    <template>
      <v-card flat class="mt-9">        
        <v-row v-if="isPhotoGalleryRoute && ![$t('default_welcome'),$t('banner'),$t('logo'),'تصویر پس‌زمینه'].includes(defaultCatName)">
          <v-col cols="6" class="my-4">
            <v-select
              :items="viewModes"
              v-model="selectedViewMode"
              :label="$t('pic.image_display_type')"
              dense
              outlined
            />
          </v-col>
          <v-col>
            <div class="d-flex align-center mt-4">
              <span class="ml-2">{{ $t('pic.image_orientation') }}</span>
              <v-btn-toggle v-model="selectedOrientation"   @input="debugOrientation"
               mandatory dense class="rounded-lg elevation-9" active-class="primary white--text">
                <v-btn value="horizontal">
                  <v-icon>mdi-rectangle-outline</v-icon>
                  <span class="mr-2">{{ $t('pic.horizontal') }}</span>
                </v-btn>
                <v-btn value="vertical">
                  <v-icon class="mdi-rotate-90">mdi-rectangle-outline</v-icon>
                  <span class="mr-2">{{ $t('pic.vertical') }}</span>
                </v-btn>
              </v-btn-toggle>
            </div>
          </v-col>
        </v-row>
        <template v-if="!onePic">
          <div class="d-flex align-center border-bottom pb-2" :dir="dir">
            <v-tabs v-model="activePanel" show-arrows background-color="transparent" class="flex-grow-1" style="max-width: calc(100% - 150px);">
              <v-tab v-for="(salon, index1) in gallery" :key="index1">
                <div v-if="editGalleryName !== index1" class="d-flex align-center rowinfo">
                  <span class="contentinfo">{{ salon.name }}</span>
                  <v-btn v-if="editName || gallery.length === 1" icon small class="ms-1" @click.stop="editGalleryName = index1">
                    <v-icon small color="grey">mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn v-if="!single" icon small class="ms-1" @click.stop="gallery.splice(index1, 1)">
                    <v-icon small color="error">mdi-close</v-icon>
                  </v-btn>
                  <help-info v-if="index1 === -1" :element-name="`${serviceName}-${componentName}-change-name`" :service-name="serviceName" :help-data="helpData" class="buttoninfo" :label="$t('change_gallery_name')" />
                </div>
                
                <div v-else class="rowinfo">
                  <v-text-field
                    v-model="salon.name" dense hide-details outlined autofocus class="contentinfo"
                    @click.stop @blur="editGalleryName = -1" @keydown.enter="editGalleryName = -1"
                  >
                    <template v-slot:append>
                      <v-btn class="mt-n1 ml-n1" icon small @click.stop="editGalleryName = -1">
                        <v-icon>mdi-check</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                  <help-info v-if="index1 === 0" :element-name="`${serviceName}-${componentName}-name`" :service-name="serviceName" :help-data="helpData" class="buttoninfo" :label="$t('gallery_name')" />
                </div>
              </v-tab>
            </v-tabs>
            
            <div v-if="!single" class="rowinfo ms-3">
               <v-btn class="btn-buy rounded-lg contentinfo px-4" depressed @click="addGallery">
                <v-icon right class="mx-2">mdi-folder-multiple-plus</v-icon> {{ $t("add_new_gallery") }}
              </v-btn>
               <help-info :element-name="`${serviceName}-${componentName}-add-gallery`" :service-name="serviceName" :help-data="helpData" class="buttoninfo" :label="$t('add_new_gallery')" />
            </div>
          </div>

          <v-divider class="mb-4"></v-divider>

          <v-tabs-items v-model="activePanel" class="transparent" :dir="dir">
            <v-tab-item v-for="(salon, index1) in gallery" :key="index1">
              <div class="d-flex justify-space-between mb-2">
                <div class="rowinfo mb-4" style="width: fit-content;">
                  <v-btn :disabled="disabled" class="btn-get-code rounded-lg contentinfo px-4" block @click="editGallery(index1)">
                    <v-icon right class="ml-2">mdi-image-plus</v-icon> {{ $t("add_photo") }}
                  </v-btn>
                  <help-info :element-name="`${serviceName}-${componentName}-data-selectimage`" :service-name="serviceName" :help-data="helpData" class="buttoninfo" :label="$t('select_photo')" />
                </div>
                <v-btn icon @click="showImages = !showImages" :title="$t('pic.change_display_mode')">
                  <v-icon>{{ showImages ? 'mdi-view-grid' : 'mdi-format-list-bulleted' }}</v-icon>
                </v-btn>
              </div>

              <div v-if="salon.images && salon.images.length > 0">
                <!-- حالت شبکه‌ای -->
                <draggable v-if="showImages" v-model="salon.images" class="row" :class="{ 'justify-center': salon.images.length === 1 }" animation="200" group="gallery-images">
                  <v-col v-for="(image, index) in salon.images" :key="image.id || index" cols="6" sm="4" md="3" style="cursor: move;">
                    <div class="rowinfo h-100">
                      <v-card hover class="rounded-lg overflow-hidden position-relative contentinfo" style="height: 100%;">
                      <v-chip
                          v-if="is_digi && image.is_main"
                          x-small
                          color="success"
                          text-color="white"
                          class="position-absolute"
                          style="top: 8px; right: 8px; z-index: 15;"
                        >
                          تصویر اصلی
                        </v-chip>

                        <div class="d-flex justify-space-between position-absolute w-100 pa-1" style="z-index: 10; background: rgba(255,255,255,0.7);">
                          <v-btn  v-if="editImg" icon small color="primary" @click.stop="selectImage(image)">
                            <v-icon small>mdi-pencil</v-icon>
                          </v-btn>
                          <div v-else></div>
                          <v-btn icon small color="error" @click.stop="deleteSelectedImage(salon, image, index)">
                            <v-icon small>mdi-delete</v-icon>
                          </v-btn>
                        </div>
                        <v-img :src="image.url" aspect-ratio="1" class="grey lighten-4" @click="selectImage(image)">
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <v-card-text class="pa-2 text-center text-truncate" :title="image.title">
                          {{ image.title || image.name || $t('pic.image') + (index + 1) }}
                        </v-card-text>
                      </v-card>
                      <help-info v-if="index1 === -1" :element-name="`${serviceName}-${componentName}-SelectedImage`" :service-name="serviceName" :help-data="helpData" class="buttoninfo" :label="$t('selected_photo')" />
                    </div>
                  </v-col>
                </draggable>

                <!-- حالت لیستی -->
                <v-list v-else class="transparent pa-0">
                  <draggable v-model="salon.images" animation="200" group="gallery-images-list">
                    <v-list-item v-for="(image, index) in salon.images" :key="image.id || index" class="mb-2 elevation-1 white rounded-lg rowinfo" style="cursor: move;">
                      <div class="d-flex w-100 align-center contentinfo">
                        <v-list-item-avatar rounded size="50">
                          <v-img :src="image.url"></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content @click="selectImage(image)" style="cursor: pointer;">
                        <v-list-item-title class="d-flex align-center">
                          <span>{{ image?.title || image?.name || $t('pic.image') + (index + 1) }}</span>
                          
                          <v-chip
                            v-if="is_digi && image.is_main"
                            x-small
                            color="success"
                            text-color="white"
                            class="mr-2"
                          >
                            تصویر اصلی
                          </v-chip>
                        </v-list-item-title>
                          
                          <v-list-item-subtitle v-text="image?.description"></v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action class="d-flex flex-row align-center">
                          <v-btn v-if="editImg" icon color="primary" class="mx-1" @click.stop="selectImage(image)">
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn icon color="error" class="mx-1" @click.stop="deleteSelectedImage(salon, image, index)">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </div>
                    </v-list-item>
                  </draggable>
                </v-list>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </template>

        <!-- حالت تک‌عکس (بدون تب) -->
        <template v-else>
          <div v-if="gallery.length > 0">
            
            <!-- دکمه افزودن و تغییر نحوه نمایش -->
            <div class="d-flex justify-space-between mb-4">
              <v-btn :disabled="disabled" class="btn-get-code rounded-lg contentinfo px-4" @click="editGallery(0)">
                <v-icon right class="ml-2">mdi-image-plus</v-icon> {{ $t("add_photo") }}
              </v-btn>
              
              <v-btn v-if="gallery[0].images && gallery[0].images.length > 0" icon @click="showImages = !showImages" :title="$t('pic.change_display_mode')">
                <v-icon>{{ showImages ? 'mdi-view-grid' : 'mdi-format-list-bulleted' }}</v-icon>
              </v-btn>
            </div>
            
            <div v-if="gallery[0].images && gallery[0].images.length > 0">
              
              <!-- حالت شبکه‌ای (Grid) برای تک‌عکس - وسط‌چین -->
              <v-row v-if="showImages" class="justify-center">
                <v-col cols="6" sm="4" md="3">
                  <div class="rowinfo h-100">
                    <v-card hover class="rounded-lg overflow-hidden position-relative contentinfo" style="height: 100%;">
                      <v-chip
                        v-if="is_digi && gallery[0].images[0].is_main"
                        x-small
                        color="success"
                        text-color="white"
                        class="position-absolute"
                        style="top: 8px; right: 8px; z-index: 15;"
                      >
                        تصویر اصلی
                      </v-chip>

                      <div class="d-flex justify-space-between position-absolute w-100 pa-1" style="z-index: 10; background: rgba(255,255,255,0.7);">
                        <v-btn v-if="editImg" icon small color="primary" @click.stop="selectImage(gallery[0].images[0])">
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                        <div v-else></div>
                        <v-btn icon small color="error" @click.stop="deleteSelectedImage(gallery[0], gallery[0].images[0], 0)">
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </div>
                      <v-img :src="gallery[0].images[0].url" aspect-ratio="1" class="grey lighten-4" @click="editImg && selectImage(gallery[0].images[0])" :style="{ cursor: editImg ? 'pointer' : 'default' }">
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <v-card-text class="pa-2 text-center text-truncate" :title="gallery[0].images[0].title">
                        {{ gallery[0].images[0].title || gallery[0].images[0].name || $t('pic.uploaded_image') }}
                      </v-card-text>
                    </v-card>
                  </div>
                </v-col>
              </v-row>

              <!-- حالت لیستی (List) برای تک‌عکس -->
              <v-list v-else class="transparent pa-0">
                <v-list-item class="mb-2 elevation-1 white rounded-lg rowinfo pa-2">
                  <div class="d-flex w-100 align-center contentinfo">
                    <v-list-item-avatar rounded size="60" class="me-4">
                      <v-img :src="gallery[0].images[0].url"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content @click="editImg && selectImage(gallery[0].images[0])" :style="{ cursor: editImg ? 'pointer' : 'default' }">
                      <v-list-item-title class="d-flex align-center">
                          <span>{{ gallery[0].images[0]?.title || gallery[0].images[0]?.name || $t('pic.uploaded_image') }}</span>
                          
                          <v-chip
                            v-if="is_digi && gallery[0].images[0].is_main"
                            x-small
                            color="success"
                            text-color="white"
                            class="mr-2"
                          >
                            تصویر اصلی
                          </v-chip>
                        </v-list-item-title>                      
                        <v-list-item-subtitle v-text="gallery[0].images[0]?.description"></v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action class="d-flex flex-row align-center">
                      <v-btn v-if="editImg" icon color="primary" class="mx-1" @click.stop="selectImage(gallery[0].images[0])">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn icon color="error" class="mx-1" @click.stop="deleteSelectedImage(gallery[0], gallery[0].images[0], 0)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </div>
                </v-list-item>
              </v-list>

            </div>
          </div>
        </template>

  <custom-popup
          id="gallery"
          v-model="dialog"
          :cons="{ title: $t('select_photo') }"
          eager
          max-width="960"
          reloadable
          @reload="getImages()"
        >
          <v-card
            :loading="loading || defLoading"
            flat
            min-height="300"
            style="overscroll-behavior: contain"
          >
            <custom-tabs
              v-model="tabs"
              :tabItems="tabItems"
              :windowItems="tabItems"
              :tabProps="{ color: 'primary' }"
              :tabsItemsAttrs="{ color: 'primary' }"
              show-arrows
              grow
            >
              <template v-slot:tab="{ tab }">
                <v-icon right>{{ tab.icon }}</v-icon>
                <span class="font-weight-bold">{{ tab.text }}</span>
                <help-info
                  :element-name="`${serviceName}-${componentName}-${tab.value}`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="`${tab.text}`"
                />
              </template>

              <template v-slot:item="{ item }">
                <div v-if="item.id === 0">
                  <together-ai-image @saved="gotoSaved" />
                </div>
                <div
                  v-else-if="item.id === 1"
                  style="
                    max-height: calc(100vh - 233px);
                    overflow-y: auto;
                    position: relative;
                  "
                >
                  <v-row
                    class="px-2 white"
                    no-gutters
                    style="position: sticky; top: 0; z-index: 1"
                  >
                    <v-col class="pa-2" cols="12" md="2">
                      <div class="rowinfo">
                        <v-select
                          v-model="per_page"
                          :items="[10, 25, 50, 100]"
                          :menu-props="{ offsetY: true }"
                          class="rounded-lg contentinfo"
                          dense
                          hide-details
                          :label="$t('count')"
                          outlined
                          @change="getDefaultImages(true)"
                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-data-perpage`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          :label="$t('count')"
                        />
                      </div>
                    </v-col>

                    <v-col class="pa-2" cols="12" md="5">
                      <div class="rowinfo">
                        <v-autocomplete
                          v-model="catSearch"
                          :items="defImg.categories"
                          class="rounded-lg contentinfo"
                          clear-icon="mdi-close-circle-outline"
                          clearable
                          dense
                          hide-details
                          :label="$t('select_category')"
                          outlined
                          @change="getDefaultImages(true)"
                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-data-catSearch`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          :label="$t('select_category')"
                        />
                      </div>
                    </v-col>

                    <v-col class="pa-2" cols="12" md="5">
                      <div class="rowinfo">
                        <v-text-field
                          v-model="search"
                          class="rounded-lg contentinfo"
                          clear-icon="mdi-close-circle-outline"
                          clearable
                          dense
                          :hint="$t('after_typing_enter')"
                          :label="$t('search')"
                          outlined
                          persistent-hint
                          @click:clear="
                            () => {
                              search = '';
                              getDefaultImages(true);
                            }
                          "
                          @keydown.enter="getDefaultImages(true)"
                        />
                        <help-info
                          :element-name="`${serviceName}-${componentName}-data-search`"
                          :service-name="serviceName"
                          :help-data="helpData"
                          class="buttoninfo"
                          :label="$t('search')"
                        />
                      </div>
                    </v-col>
                  </v-row>

                  <v-row
                    v-if="!!defImg.items && showDefResult"
                    class="pa-3 custom-scrollbar"
                    no-gutters
                  >
                    <v-col
                      v-if="
                        (!defImg.items.data || !defImg.items.data.length) &&
                        !defLoading
                      "
                      class="pa-2"
                      cols="12"
                    >
                      <v-card-title class="text-center justify-center">
                        {{ $t("no_image_available") }}
                      </v-card-title>
                    </v-col>

                    <template v-else>
                      <v-col
                        v-for="(image, i) in defImg.items.data"
                        :key="`defImg-data-${i}`"
                        :data-img="image.id"
                        class="pa-1"
                        cols="12"
                        md="4"
                        @click="select(image)"
                      >
                        <v-img
                          :key="`defImg-data-0-${i}-${image.id}`"
                          :aspect-ratio="imageAspectRatio"
                          :class="
                            computedEditingGallery.images.findIndex(
                              (item) => item.id === image.id,
                            ) > -1
                              ? 'border border-2 border-success'
                              : ''
                          "
                          :lazy-src="image.full_path"
                          :src="image.full_path"
                          class="rounded"
                        >
                          <template
                            v-if="
                              computedEditingGallery.images.findIndex(
                                (item) => item.id === image.id,
                              ) > -1
                            "
                            v-slot:default
                          >
                            <v-checkbox
                              :input-value="true"
                              class="ma-2"
                              color="success"
                              dense
                              hide-details
                              readonly
                            />
                          </template>
                        </v-img>
                      </v-col>

                      <v-col cols="12">
                        <v-card
                          v-if="
                            !defLoading &&
                            !defIsLastPage &&
                            tabs === 1 &&
                            !getDefError
                          "
                          v-intersect="onDefaultIntersect"
                          flat
                          height="200"
                        >
                          <v-progress-circular
                            color="primary"
                            indeterminate
                            size="35"
                            width="5"
                          />
                        </v-card>
                      </v-col>
                    </template>
                  </v-row>

                  <v-card
                    v-else-if="!defLoading"
                    class="d-flex flex-column align-center justify-center mx-auto"
                    flat
                    max-width="400"
                  >
                    <v-img max-width="120" src="/media/img/has_no_image.jpg" />
                    <v-card-text class="text-center">
                      {{ $t("to_use_ready_images_search_category_or_product") }}
                    </v-card-text>
                  </v-card>
                </div>
                <div v-else-if="item.id === 2">
                  <v-card class="pa-2" flat>
                    <slot name="default">
                      <v-card-text>
                        <v-file-input
                          ref="fileInput"
                          v-model="filesModel"
                          :loading="upLoading"
                          accept="image/png,image/jpeg"
                          class="d-none"
                          clearable
                          dense
                          :hint="$t('max_file_size_2mb')"
                          multiple
                          outlined
                          truncate-length="7"
                          @change="handleFileUpload"
                          @click:clear="filesModel = null"
                        />
                      </v-card-text>

                      <v-card
                        id="uploader"
                        ref="uploader"
                        class="mx-auto d-flex justify-center align-center rounded-xl flex-column overflow-hidden"
                        height="200"
                        max-width="700"
                        outlined
                        @click="dragEvent"
                        @dragleave="dragEvent"
                        @dragover="dragEvent"
                        @drop="dragEvent"
                      >
                        <v-icon size="68" style="opacity: 0.4"
                          >mdi-cloud-upload-outline</v-icon
                        >
                        <v-card-title class="justify-center">{{
                          $t("upload_file")
                        }}</v-card-title>
                        <v-card-text class="text-center pt-0">
                          {{ $t("drag_and_drop_to_upload_or") }}
                          <v-btn
                            class="mx-1"
                            color="primary"
                            min-width="75"
                            small
                          >
                            {{ $t("here") }}
                          </v-btn>
                          {{ $t("click") }}
                        </v-card-text>
                      </v-card>

                      <v-card
                        class="d-flex flex-wrap mx-auto pa-2"
                        flat
                        max-width="700"
                      >
                        <div
                          v-for="(item, i) in filesPreview"
                          :key="`filesPreview-${i}`"
                          class="pa-1 text-center d-flex justify-space-between flex-column"
                          style="max-width: 100px; width: 100px"
                        >
                          <div>
                            <v-img
                              :src="item.url"
                              :aspect-ratio="1"
                              class="rounded-lg"
                              width="100%"
                            >
                              <div
                                v-if="
                                  !upLoading && (!item.status || !item.color)
                                "
                                class="text-left fill-height"
                              >
                                <v-btn icon @click="removeFileFromUpload(i)">
                                  <v-icon>mdi-delete</v-icon>
                                </v-btn>
                              </div>

                              <div
                                v-else-if="
                                  upLoading && item.status === 'loading'
                                "
                                class="d-flex justify-center align-center fill-height"
                                style="background: rgba(0, 0, 0, 0.5)"
                              >
                                <v-progress-circular
                                  color="white"
                                  indeterminate
                                  size="40"
                                  width="5"
                                />
                              </div>

                              <v-card
                                v-else-if="!!item.color"
                                class="d-flex align-center justify-center"
                                color="rgba(0, 0, 0, .5)"
                                flat
                                height="100%"
                                width="100%"
                              >
                                <v-avatar :color="item.color">
                                  <v-icon
                                    >mdi-{{
                                      !!item.status ? "check" : "close"
                                    }}</v-icon
                                  >
                                </v-avatar>
                              </v-card>
                            </v-img>
                          </div>
                          <span class="mt-1">{{ item.name }}</span>
                        </div>
                      </v-card>
                    </slot>

                    <v-card-text>
                      <slot
                        name="extension"
                        v-bind="{ cats: computedCats, def: defaultCatName }"
                      >
                        <cat-to-upload
                          v-if="showCatUpload"
                          v-model="categoryName"
                          :items="computedCats"
                          :loading="upLoading"
                          @action="uploadFiles"
                          @clear="clearUpload"
                        />
                      </slot>
                    </v-card-text>
                  </v-card>
                </div>
                <div v-else-if="item.id === 3">
                  <v-tabs
                    v-model="innerTabs"
                    color="deep-purple accent-4"
                    light
                  >
                    <v-tab>{{ $t("all") }}</v-tab>
                    <v-tab v-for="(category, j) in img.categories" :key="j">{{
                      category
                    }}</v-tab>
                  </v-tabs>

                  <v-divider class="my-0" />

                  <v-tabs-items v-model="innerTabs">
                    <v-tab-item>
                      <v-row
                        class="pa-3 custom-scrollbar"
                        no-gutters
                        style="max-height: calc(90vh - 300px); overflow-y: auto"
                      >
                        <v-col
                          v-for="(image, ind) in img.items.data"
                          :key="ind"
                          :data-img="image.id"
                          class="pa-1"
                          cols="12"
                          md="4"
                          @click="select(image)"
                        >
                          <v-img
                            :key="image.id"
                            :aspect-ratio="16 / 9"
                            :class="
                              computedEditingGallery.images.findIndex(
                                (item) => item.id === image.id,
                              ) > -1
                                ? 'border border-2 border-success'
                                : ''
                            "
                            :lazy-src="image.full_path"
                            :src="image.full_path"
                            class="rounded"
                          >
                            <template
                              v-if="
                                computedEditingGallery.images.findIndex(
                                  (item) => item.id === image.id,
                                ) > -1
                              "
                              v-slot:default
                            >
                              <v-checkbox
                                :input-value="true"
                                class="ma-2"
                                color="success"
                                dense
                                hide-details
                                readonly
                              />
                            </template>
                          </v-img>
                        </v-col>

                        <v-col cols="12">
                          <v-card
                            v-if="
                              !loading && !isLastPage && tabs === 3 && !getError
                            "
                            v-intersect="onIntersect"
                          >
                            <v-progress-circular
                              color="primary"
                              indeterminate
                              size="35"
                              width="5"
                            />
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-tab-item>

                    <v-tab-item v-for="(item, j) in img.categories" :key="j">
                      <v-row
                        v-if="!!img.items && !!img.items.data"
                        class="pa-3 custom-scrollbar"
                        no-gutters
                        style="max-height: calc(90vh - 300px); overflow-y: auto"
                      >
                        <v-col
                          v-for="image in img.items.data.filter(
                            (itemImg) => itemImg.category === item,
                          )"
                          :key="image.id"
                          :data-img="image.id"
                          class="pa-1"
                          cols="12"
                          md="4"
                          @click="select(image)"
                        >
                          <v-img
                            :key="image.id"
                            :aspect-ratio="16 / 9"
                            :class="
                              computedEditingGallery.images.findIndex(
                                (item) => item.id === image.id,
                              ) > -1
                                ? 'border border-2 border-success'
                                : ''
                            "
                            :lazy-src="image.full_path"
                            :src="image.full_path"
                            class="rounded"
                          >
                            <template
                              v-if="
                                computedEditingGallery.images.findIndex(
                                  (item) => item.id === image.id,
                                ) > -1
                              "
                              v-slot:default
                            >
                              <v-checkbox
                                :input-value="true"
                                class="ma-2"
                                color="success"
                                dense
                                hide-details
                                readonly
                              />
                            </template>
                          </v-img>

                          <!--                            <v-img :key="image.id" :aspect-ratio="16/9" :lazy-src="image.full_path"-->
                          <!--                                   :src="image.full_path" class="rounded"/>-->
                        </v-col>

                        <v-col cols="12">
                          <v-card
                            v-if="
                              !loading && !isLastPage && tabs === 3 && !getError
                            "
                            v-intersect="onIntersect"
                          >
                            <v-progress-circular
                              color="primary"
                              indeterminate
                              size="35"
                              width="5"
                            />
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                  </v-tabs-items>

                  <v-card
                    v-if="
                      !loading &&
                      (!img.categories ||
                        !img.categories.length ||
                        !img.items.data ||
                        !img.items.data.length)
                    "
                    flat
                    style="max-height: calc(90vh - 250px); overflow-y: auto"
                    width="100%"
                  >
                    <v-card-title class="text-center justify-center">{{
                      $t("no_image_found")
                    }}</v-card-title>
                    <v-card-subtitle class="text-center">{{
                      $t("for_adding_file_use_upload_center")
                    }}</v-card-subtitle>
                  </v-card>
                </div>
                <div v-else-if="item.id === 4">
                  <v-card class="pa-2 pt-0">
                    <v-card-title>{{ $t("add_image") }}</v-card-title>
                    <v-card-subtitle>
                      {{ $t("to_use_external_image_link_fill_fields") }}
                    </v-card-subtitle>

                    <v-row justify="center" no-gutters>
                      <!--                        <v-col class="pa-2" cols="12" lg="5" md="6">-->
                      <!--                          <v-text-field v-model="manualImage.title" class="my-2" dense hide-details label="عنوان"-->
                      <!--                                        outlined/>-->
                      <!--                        </v-col>-->

                      <!--                        <v-col class="pa-2" cols="12" lg="5" md="6">-->
                      <!--                          <v-text-field v-model="manualImage.link" class="my-2" dense hide-details-->
                      <!--                                        :label="$t('link')" outlined/>-->
                      <!--                        </v-col>-->

                      <v-col
                        v-for="(m, i) in manualImage"
                        :key="i"
                        class="pa-2"
                        cols="12"
                        lg="10"
                        md="11"
                      >
                        <div class="rowinfo">
                          <v-text-field
                            v-model="m.url"
                            :rules="[rules.link]"
                            class="my-2 contentinfo"
                            dense
                            :hint="$t('image_url_hint')"
                            :label="$t('image_url')"
                            outlined
                            persistent-hint
                          >
                            <template v-if="!onePic" v-slot:append>
                              <v-btn
                                class="mt-n1 ml-n1 contentinfo"
                                icon
                                @click="pushManual"
                              >
                                <v-icon>mdi-plus</v-icon>
                              </v-btn>
                            </template>
                          </v-text-field>
                          <help-info
                            v-if="i === 0"
                            :element-name="`${serviceName}-${componentName}-data-url`"
                            :service-name="serviceName"
                            :help-data="helpData"
                            class="buttoninfo"
                            :label="$t('image_url')"
                          />
                        </div>
                      </v-col>

                      <!--                        <v-col class="pa-2" cols="12" lg="5" md="6">-->
                      <!--                          <v-textarea v-model="manualImage.description" class="my-2" dense hide-details-->
                      <!--                                      :label="$t('description')" maxLength="250" outlined rows="1"/>-->

                      <!--                        </v-col>-->

                      <v-col class="text-left px-2 pb-2" cols="12" lg="10">
                        <div class="rowinfo">
                          <v-btn
                            class="btn-sub ms-auto px-8 contentinfo"
                            color="green lighten-3"
                            @click="addImageManual(computedEditingGallery)"
                          >
                            {{ $t("add") }}
                          </v-btn>
                          <help-info
                            :element-name="`${serviceName}-${componentName}-data-url`"
                            :service-name="serviceName"
                            :help-data="helpData"
                            class="buttoninfo"
                            :label="$t('add')"
                          />
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
              </template>
            </custom-tabs>
          </v-card>
        </custom-popup>

        <custom-popup
          v-if="editImg"
          id="edit-gallery"
          v-model="editDialog"
          :cons="cons"
          max-width="500"
        >
          <v-card class="p-8">
            <div class="rowinfo">
              <v-text-field
                v-model="selectedImage.title"
                class="my-2 contnetinfo"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                hide-details
                :label="$t('title')"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-selectedImage-title`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('title')"
              />
            </div>
            <div class="rowinfo">
              <v-text-field
                v-model="selectedImage.link"
                :rules="[rules.link]"
                class="my-2 contentinfo"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                hide-details
                :label="$t('link')"
                outlined
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-selectedImage-title`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('link')"
              />
            </div>
            <div class="rowinfo">
              <v-textarea
                v-model="selectedImage.description"
                class="my-2 contentinfo"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                hide-details
                :label="$t('description')"
                maxLength="250"
                outlined
                rows="5"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-selectedImage-description`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('description')"
              />
            </div>
                        <!-- فیلدهای اختصاصی دیجی‌کالا / سئو -->
            <template v-if="is_digi">
              <div class="rowinfo">
                <v-text-field
                  v-model="selectedImage.alt"
                  class="my-2 contentinfo"
                  clear-icon="mdi-close-circle-outline"
                  clearable
                  dense
                  hide-details
                  label="متن جایگزین (Alt)"
                  outlined
                />
              </div>

              <div class="rowinfo">
                <v-switch
                  v-model="selectedImage.is_main"
                  class="my-2 contentinfo"
                  dense
                  hide-details
                  color="primary"
                  label="تصویر (اصلی)"
                  @change="onMainImageToggle(selectedImage)"
                />
              </div>
            </template>

          </v-card>
        </custom-popup>

      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import { ir } from "../../../check_domain_ir";
import { rbAxios } from "@/main";
import CatToUpload from "./catToUpload";
import TogetherAiImage from "@/view/components/adapters/AIGeneration/togetherAiImage.vue";

export default {
  name: "picSelector",

  components: { TogetherAiImage, CatToUpload },

  props: {
      is_digi: {
      type: Boolean,
      default: false,
    },
    bracket: String,
    data: {
      type: Object,
      require: true,
    },
    defaultCatName: String,
    disabled: Boolean,
    editImg: {
      type: Boolean,
      default: true,
    },
    editName: {
      type: Boolean,
      default: true,
    },
    field: String,
    onePic: Boolean,
    value: Array,
    single: Boolean,
  },

  data() {
    return {
      dir: 'rtl',
      activePanel: null,
      viewModes: [
        { text: "شبکه‌ای", value: "grid" },
        { text: "اسلایدر", value: "slider" },
      ],

      helpData: [],
      serviceName: "Qrland",
      componentName: "picselector",

      upLoading: false,
      loading: false,
      defLoading: false,
      dialog: false,
      manualDialog: false,
      editDialog: false,
      editingGallery: null,
      tabs: 0,
      innerTabs: 0,
      filesModel: null,
      filesPreview: [],
      categoryName: "",
      getError: false,
      getDefError: false,
      img: {
        items: {},
        categories: [],
      },
      defImg: {
        items: {},
      },
      isIntersecting: false,
      defIsLastPage: false,
      isLastPage: false,
      defPage: 1,
      page: 1,
      catSearch: undefined,
      search: undefined,
      showDefResult: false,
      per_page: 10,
      cats: [],
      url: process.env.VUE_APP_ROBOT,
      manualImage: [
        {
          title: "",
          url: "",
          description: "",
          link: "",
        },
      ],
      selectedImage: {},
      editGalleryName: -1,
      showImages: false,
    };
  },

  computed: {
  selectedOrientation: {
  get: function () {
    var data = this.data || {};
    var picSelector = data.PicSelector || {};

    return picSelector.orientation || "horizontal";
  },

  set: function (val) {
    var data = this.data || {};

    if (!data.PicSelector) {
      this.$set(data, "PicSelector", {});
    }

    this.$set(
      data.PicSelector,
      "orientation",
      val
    );

    this.$emit(
      "change",
      Object.assign({}, data.PicSelector)
    );
  }
},

    imageAspectRatio() {
      return this.selectedOrientation === 'vertical' ? 9 / 16 : 16 / 9;
    },
    selectedViewMode: {
      get() {
        const section = this.data?.PicSelector || {};
        if (section.slider) return "slider";
        if (section.grid) return "grid";
        return "slider";
      },
      set(val) {
        if (!this.data?.PicSelector) {
          this.$set(this.data, 'PicSelector', {});
        }
        this.$set(this.data.PicSelector, 'slider', val === "slider");
        this.$set(this.data.PicSelector, 'grid', val === "grid");
        this.$emit("change");
      },
    },
    isPhotoGalleryRoute() {
      return [
        "qr.photo", "qr.name.editPhoto", "qr.name.id.editPhoto",
        "qr.gift", "qr.name.editgift", "qr.name.id.editgift",
        'modelsList.memories.edit', 'qr.create.memories',
        'qr.create.photoGalleryModel', 'qr.create.photoGalleryedit',
        'qr.name.edit','qr.name.id.edit','qr.cardVisit',
        'qr.cardVisitPro','qr.name.edit.pro','qr.name.id.edit.pro'
      ].includes(this.$route.name);
    },
    rules() {
      return {
        link: (v) => !v || this.isLink(v) || this.$t("enter_valid_link"),
      };
    },
    tabItems() {
      return [
        { id: 0, text: this.$t("create_image"), icon: "mdi-image-auto-adjust", value: "generate-image" },
        { id: 1, text: this.$t("ready_images"), icon: "mdi-broadcast", value: "ready-image" },
        { id: 2, text: this.$t("add_image"), icon: "mdi-cloud-upload-outline", value: "add-image" },
        { id: 3, text: this.$t("image_gallery"), icon: "mdi-image-area-close", value: "gallery-image" },
        { id: 4, text: this.$t("link"), icon: "mdi-link-plus", value: "link-image" },
      ];
    },
    cons() {
      return {
        title: this.$t("edit_image"),
        buttons: [{ type: "submit", handler: this.changeObj }],
      };
    },
    computedCats() {
      if (!!this.img.categories?.length && !this.img.categories.includes(this.defaultCatName)) {
        let arr = [];
        arr.push(this.defaultCatName);
        return [...arr, ...this.img.categories];
      }
      return this.img.categories;
    },
    showCatUpload() {
      return (
        !this.$slots.extension &&
        !!this.filesModel &&
        typeof this.filesModel === "object" &&
        !!this.filesModel.length
      );
    },
        gallery: {
      get() {
        if (this.single && this.onePic) {
          return [
            {
              name: "",
              images: this.field ? [
                {
                  name: this.field.split("/").pop().toString(),
                  title: "",
                  url: this.field,
                  description: "",
                  link: "",
                  id: "",
                },
              ] : [],
            },
          ];
        }

        if (!!this.value?.length) {
          return this.value;
        }

        if (!!this.data?.gallery && this.data.gallery.length > 0) {
          return this.data.gallery;
        }

        // ۳. حالت پیش‌فرض برای زمانی که هیچ عکسی وجود ندارد
        return [
          {
            name: "",
            images: [],
          },
        ];
      },
      set(val) {
        // جلوگیری از ذخیره شدن آرایه گالری در حالت فیلد/تک‌عکس
        if (this.single && this.onePic) return;

        if (!!this.value) this.$emit("input", val);
        if (!!this.data) {
          this.data["gallery"] = val;
        }

        this.$emit("change");
        this.$nextTick(() => {
          this.$root.$emit("fetchDragList");
        });
      },
    },

    computedEditingGallery: {
      get() {
        return this.gallery[this.editingGallery] || null;
      },
      set(val) {
        // در حالت تک عکس، از تغییر مرجع اصلی گالری جلوگیری میکنیم
        if (this.single && this.onePic) return;
        this.gallery[this.editingGallery] = val;
      },
    },
  },

  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    dialog(val) {
      if (val) {
        this.getError = this.getDefError = false;
      }
    },
    tabs(val) {
      if (val === 1 && (!this.defImg.items || !this.defImg.items.data) && !this.defLoading) {
        this.getDefaultImages();
      } else if (val === 3 && (!this.img.items || !this.img.items.data) && !this.loading) {
        this.getImages();
      }
    },
    innerTabs(val) {
      this.page = 1;
      this.isLastPage = false;
      this.isIntersecting = false;
      this.img.items = [];
      this.$nextTick(() => {
        this.getImages();
      });
    },
    showCatUpload(val) {
      if (val && (!this.img?.categories || !this.img.categories.length))
        this.getImages();
    },
    field: {
      deep: true,
      handler(val) {
        this.$emit("change", val);
      },
    },
  },

  methods: {
      onMainImageToggle(activeImage) {
      if (!this.is_digi || !activeImage.is_main) return;      
      const currentGallery = this.computedEditingGallery || (this.gallery && this.gallery[0]);
      const images = currentGallery?.images || [];

      images.forEach((img) => {
        if (img !== activeImage) {
          this.$set(img, 'is_main', false);
        }
      });
    },
     debugOrientation: function (value) {
    console.log("toggle input:", value);

    this.$nextTick(function () {
      console.log(
        "data orientation:",
        this.data &&
        this.data.PicSelector &&
        this.data.PicSelector.orientation
      );
    });
  },
    isLink(str) {
      const regex = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
      const without_regex = new RegExp("^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
      return regex.test(str) || without_regex.test(str);
    },
    select(image) {
      if (!this.computedEditingGallery.images.find((item) => item.id === image.id)) {
        if (this.onePic) {
          this.$emit("update:field", image.full_path);
          // در حالت تکی فقط به والد اطلاع میدیم
        } else {
          let arr = this.computedEditingGallery.images;
          if(this.is_digi)
          arr.push({
            name: image.title,
            title: "",
            url: image.full_path,
            description: "",
            link: "",
            id: image.id,
            alt: image.title || "",
            is_main: this.is_digi ? arr.length === 0 : false, 
          });
          else
          arr.push({
            name: image.title,
            title: "",
            url: image.full_path,
            description: "",
            link: "",
            id: image.id,
          });

          this.computedEditingGallery.images = arr;
        }
      } else {
        this.deleteSelectedImage(this.computedEditingGallery, image);
      }
    },
    async getDefaultImages(search = false) {
      this.defLoading = true;
      if (search) {
        this.showDefResult = true;
        this.defPage = 1;
        this.defIsLastPage = false;
        this.isIntersecting = false;
        this.defImg.items.data = [];
      }
      const local_url = ir(this.url);

      await rbAxios.get(`${local_url}/files/special`, {
          params: {
            bracket: this.bracket ?? undefined,
            paginate: 1,
            page: this.defPage,
            category: this.catSearch,
            search: this.search,
            length: this.per_page,
          },
        })
        .then(({ data }) => {
          let lastImg = search ? [] : this.defImg?.items?.data || [];
          let temp = data.data;
          temp.items.data = lastImg.concat(temp.items.data);
          this.defImg = temp;
          this.defIsLastPage = !data.data.items.next_page_url;
          this.defPage++;
        })
        .catch(() => {
          this.getDefError = true;
        })
        .finally(() => (this.defLoading = false));
    },
    async getImages(i) {
      this.loading = true;
      let params = {
        paginate: 1,
        page: this.page,
        category: i ?? this.innerTabs > 0 ? this.img.categories[this.innerTabs - 1] : undefined,
        dir: "desc",
      };
      const local_url = ir(this.url);

      await rbAxios.get(`${local_url}/files`, { params })
        .then(({ data }) => {
          let lastImg = this.img?.items?.data || [];
          let temp = data.data;
          temp.items.data = lastImg.concat(temp.items.data);
          this.img = temp;
          if (!!this.defaultCatName) this.categoryName = this.defaultCatName;
          this.isLastPage = !data.data.items.next_page_url;
          this.page++;
        })
        .catch(() => {
          this.getError = true;
        })
        .finally(() => (this.loading = false));
    },
    moveUp(salon, image) {
      if (this.single && this.onePic) return;
      let imageIndex = salon.images.indexOf(image);
      let previousIndex = imageIndex - 1;
      let tempPreviousImage = { ...salon.images[previousIndex] };
      let tempCurrentImage = { ...image };

      salon.images[imageIndex] = tempPreviousImage;
      salon.images[previousIndex] = tempCurrentImage;

      this.$forceUpdate();

      let gallery = this.gallery;
      if (this.value) {
        this.$emit("input", [{ name: "", images: [] }]);
        this.$nextTick(() => {
          this.$emit("input", gallery);
        });
      } else {
        this.data["gallery"] = null;
        this.$nextTick(() => {
          this.data["gallery"] = gallery;
        });
      }
    },
    moveDown(salon, image) {
      if (this.single && this.onePic) return;
      let imageIndex = salon.images.indexOf(image);
      let nextIndex = imageIndex + 1;
      let tempPreviousImage = { ...salon.images[nextIndex] };
      let tempCurrentImage = { ...image };

      salon.images[imageIndex] = tempPreviousImage;
      salon.images[nextIndex] = tempCurrentImage;

      this.$forceUpdate();

      let gallery = this.gallery;
      if (this.value) {
        this.$emit("input", { name: "", images: [] });
        this.$nextTick(() => {
          this.$emit("input", gallery);
        });
      } else {
        this.data["gallery"] = null;
        this.$nextTick(() => {
          this.data["gallery"] = gallery;
        });
      }
    },
    addGallery() {
      this.gallery.push({
        name: this.$t("photo_gallery") + this.gallery.length,
        images: [],
      });
    },
    editGallery(index) {
      this.dialog = true;
      this.editingGallery = index;
    },
    deleteSelectedImage(salon, image) {
      let index = salon?.images?.findIndex((item) =>
        !!item.id ? item.id === image.id : item.url === image.url,
      );
      if (index > -1) salon?.images?.splice(index, 1);

      if (this.single && this.onePic) {
        this.$emit("update:field", "");
      }
    },
    pushManual() {
      this.manualImage.push({
        title: "", url: "", description: "", link: "",
      });
    },
    addImageManual(salon) {
      if (this.onePic) {
        let v = { ...this.manualImage[0] };
        this.$emit("update:field", v.url);
        this.$emit("change");
      } else {
        this.manualImage
          .filter((item) => !!item.url && this.isLink(item.url))
          .forEach((item) => {
            salon.images.push({
              ...item,
              alt: item.alt || item.title || "",
              is_main: this.is_digi ? salon.images.length === 0 : false,
            });
          });
      }

      this.manualDialog = false;
      this.dialog = false;
      this.manualImage = [{ name: "", title: "", url: "", description: "", link: "" }];
    },
    selectImage(image) {
      if (this.is_digi) {
        if (image.alt === undefined) this.$set(image, "alt", image.title || "");
        if (image.is_main === undefined) this.$set(image, "is_main", false);
      }
      this.selectedImage = image;
      this.editDialog = true;
    },
    onDefaultIntersect(entries) {
      this.isIntersecting = entries[0].isIntersecting;
      this.$nextTick(() => {
        if ((this.isIntersecting || !this.defImg.items.data) && !this.defIsLastPage) {
          this.getDefaultImages();
        }
      });
    },
    onIntersect(entries) {
      this.isIntersecting = entries[0].isIntersecting;
      this.$nextTick(() => {
        if ((this.isIntersecting || !this.img.items.data) && !this.isLastPage)
          this.getImages();
      });
    },
    changeObj() {
      let gallery = this.gallery;
      if (!!this.data && !(this.single && this.onePic)) {
        this.data["gallery"] = null;
        this.data["gallery"] = gallery;
      }
      if (!!this.value && !(this.single && this.onePic)) {
        this.$emit("input", this.value);
      }
      this.editDialog = false;
    },
    handleFileUpload(event) {
      let arr = Array.from(event);
      if (!!arr && !!arr.length) {
        for (const file of arr) {
          if (file.type.match("image.*")) {
            const reader = new FileReader();
            reader.onload = (e) => {
              if (e.total > 2000000) {
                let index = this.filesModel.findIndex((f) => f.name === file.name);
                this.filesModel.splice(index, 1);
                this.$toast.error(this.$t("max_background_image_size_2mb"));
                return;
              }
              this.filesPreview.push({ url: e.target.result, name: file.name });
            };
            reader.readAsDataURL(file);
          }
        }
      }
      this.$forceUpdate();
    },
    async uploadFiles(name = this.categoryName) {
      for (const file of this.filesModel) {
        await this.uploadToServer(file, name);
      }
    },
    clearUpload() {
      this.filesModel = null;
      this.filesPreview = [];
      this.categoryName = this.defaultCatName || "";
    },
    dragEvent(e) {
      e.stopPropagation();
      e.preventDefault();
      let uploader = this.$refs.uploader;
      if (e.type === "dragover" && !uploader.$el.classList.contains("drag-over"))
        uploader.$el.classList.add("drag-over");
      else if (e.type === "dragleave" && uploader.$el.classList.contains("drag-over"))
        uploader.$el.classList.remove("drag-over");
      else if (e.type === "drop") {
        uploader.$el.classList.remove("drag-over");
        const files = e.target.files || e.dataTransfer.files;
        let arr = [];
        for (const file of files) {
          arr.push(file);
        }
        this.filesModel = arr;
        this.handleFileUpload(files);
      } else if (e.type === "click") {
        this.$refs.fileInput.$refs.input.click();
      }
    },
    removeFileFromUpload(index) {
      this.filesModel.splice(index, 1);
      this.filesPreview.splice(index, 1);
    },
    async uploadToServer(file, name) {
      const formData = new FormData();
      this.upLoading = true;
      const index = this.filesModel.indexOf(file);
      let cat = typeof name === "string" ? name : this.categoryName;

      formData.append("file", file);
      formData.append("category", cat);
      formData.append("type", "other");
      formData.append("file_type", "image");

      try {
        this.filesPreview[index].status = "loading";
        await rbAxios.post("/files", formData)
          .then(() => {
            this.filesPreview[index].status = true;
            this.filesPreview[index].color = "success";
            if (!!this.filesModel.length && index + 1 >= this.filesModel.length) {
              this.filesModel = null;
              this.filesPreview = [];
              this.$toast.success(this.$t("uploaded_successfully"));
              this.gotoSaved(cat);
            }
          })
          .catch(() => {
            this.filesPreview[index].status = false;
            this.filesPreview[index].color = "error";
            this.$toast.error(this.$t("image_upload_error"));
          });
      } catch (e) {
        console.log(e);
      }
      this.upLoading = false;
    },
    gotoSaved(cat) {
      this.tabs = 3;
      this.page = 1;
      this.img.items = [];
      let it = this.img.categories.findIndex((item) => item === cat) + 1;
      if (it < 0) it = 0;
      this.getImages(it).then(() => {
        this.innerTabs = it;
      });
    },
  },
};

</script>

<style scoped>
.v-tabs >>> .v-tabs-slider-wrapper {
  display: block !important;
}

@media screen and (max-width: 600px) {
  .v-tabs >>> .v-slide-group__prev {
    display: none !important;
  }
}

#uploader {
  transition: all 0.3s ease;
  background-color: rgba(0, 0, 0, 0.2);
  border: 2px dashed #797979 !important;
}

.drag-over {
  border: 2px dashed #fff !important;
  background-color: rgba(33, 150, 243, 0.33) !important;
}

@media screen and (max-width: 600px) {
  .v-card >>> .v-expansion-panel-content__wrap {
    padding: 0 !important;
  }
}
.primary.white--text .v-icon {
  color: white !important;
}
</style>
